import { createFileRoute } from "@tanstack/react-router";
import Pagamentos from "@/pages/app/Pagamentos";

export const Route = createFileRoute("/app/perfil/pagamentos")({
  head: () => ({ meta: [{ title: "Pagamentos | Braussie - Nutri" }] }),
  component: Pagamentos,
});
